import { Build } from "@dashboard/products/types";

type Artifact = Build["artifacts"][number];

const isUploadedFirmware = (artifact: Artifact) => artifact.type === "os-firmware" && artifact.isUploaded;

export const getFirmwareArtifacts = (build: Build) => (build.artifacts ?? []).filter(isUploadedFirmware);

export const getFirmwareDownloads = (build: Build) =>
    getFirmwareArtifacts(build).reduce((sum, artifact) => sum + artifact.downloads, 0);
